export default __webpack_public_path__ + "static/1-c3a7a921650788e6c7161ef94ba0330f.png";